<script setup>
</script>

<template>
  <section class="section">
    <div class="wrap grid-portrait">
      <figure class="portrait" data-fallback="Portret volgt">
        <img src="/images/finance-3.jpg" alt="Portret van Adriaan"
             @error="$event.target.style.display='none'" />
      </figure>
      <div>
        <h1>Wie ben ik</h1>
        <p>
          Genoeg van gefrustreerdheid, irritatie, boosheid. Wars van "doe maar normaal, dan doe je al gek genoeg" ben ik, Adriaan begonnen met dit bedrijf om mijn energie te richten op de positieve dingen des levens en om "Den Gehelen Menschheid" te laten zien dát het WEL kan.<br><br>

          In het dagelijks leven ondersteun ik mensen met meervoudige problematieken. Ben ik getrouwd, geen kinderen, wel 2 katten en een grote fruit, kruiden en bloemen tuin. Wordt ik regelmatig door anderen gezien als die engel, die knuffelbeer, die volslagen idiote wijze.
        </p>
        <blockquote class="quote">
          "You might think I'm crazy, but I think that you're wild, when you flash that fragile smile."
          <cite>— The Cars, "You Might Think" (1984)</cite>
        </blockquote>
        <div class="actions">
          <router-link class="btn btn-primary" to="/contact">Contact</router-link>
        </div>
      </div>
    </div>
  </section>
</template>
